/**
 * Målganger per seilnummer — til båtlistene på kartene (reprise og live).
 */
import type { FinishRecord } from './api.ts';

/** Seilnummer slik de sammenlignes — tidtakeren taster fritt («gj 219» = «GJ219»). */
export function sailKey(s: string): string {
  return s.replace(/\s+/g, '').toUpperCase();
}

export interface Maalgang {
  position: number | null;
  elapsedMs: number;
}

/**
 * Målganger med tid. GPS-forslaget brukes når komiteen ikke har ført tid (men ikke
 * når raden har en merknad, f.eks. DNF).
 */
export function maalgangerPerSeil(records: FinishRecord[] | undefined): Map<string, Maalgang> {
  const m = new Map<string, Maalgang>();
  for (const r of records ?? []) {
    const elapsedMs = r.elapsedMs ?? (r.note ? null : (r.autoElapsedMs ?? null));
    if (!r.sailNumber || elapsedMs == null) continue;
    m.set(sailKey(r.sailNumber), { position: r.position, elapsedMs });
  }
  return m;
}

/** Seilnumrene som er ferdige: i mål med tid, eller med merknad (DNF, DNS …). */
export function ferdigeSeil(records: FinishRecord[] | undefined): Set<string> {
  const s = new Set<string>();
  for (const r of records ?? []) {
    if (r.sailNumber && (r.elapsedMs != null || r.autoElapsedMs != null || r.note)) s.add(sailKey(r.sailNumber));
  }
  return s;
}

/** Båtlista: båtene i mål først (plass, så tid), resten etter seilnummer. */
export function sorterMedMaal<T extends { sailNumber: string; maal: Maalgang | null }>(rader: T[]): T[] {
  return [...rader].sort((a, b) =>
    a.maal && b.maal
      ? (a.maal.position ?? Infinity) - (b.maal.position ?? Infinity) || a.maal.elapsedMs - b.maal.elapsedMs
      : a.maal
      ? -1
      : b.maal
      ? 1
      : a.sailNumber.localeCompare(b.sailNumber),
  );
}
